import React from 'react';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '../ui/accordion';
import { FAQS, BRANDS } from '../../data/site';
import { Reveal } from '../common/Reveal';

export const FaqSection = () => (
  <section className="py-24 bg-background" data-testid="faq-section">
    <div className="max-w-3xl mx-auto px-4">
      <Reveal className="text-center">
        <span className="eyebrow justify-center">FAQ</span>
        <h2 className="section-title mt-4" data-testid="faq-title">Frequently Asked Roofing Questions</h2>
        <p className="mt-4 text-lg text-muted-foreground">Answers to Common Roofing Concerns in New Jersey</p>
      </Reveal>
      <Reveal delay={0.1}>
        <Accordion type="single" collapsible defaultValue="faq-0" className="mt-12 space-y-4">
          {FAQS.map((f, i) => (
            <AccordionItem
              key={f.q}
              value={`faq-${i}`}
              className="border border-border rounded-2xl px-2 data-[state=open]:border-primary/40 data-[state=open]:shadow-card transition-shadow"
              data-testid={`faq-item-${i}`}
            >
              <AccordionTrigger className="px-4 py-5 font-heading font-bold text-base md:text-lg hover:no-underline text-left data-[state=open]:text-primary">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="px-4 pb-6 text-base text-muted-foreground whitespace-pre-line">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);

export const Brands = () => (
  <section className="py-14 bg-background border-y border-border overflow-hidden" data-testid="brands-section">
    <p className="text-center font-heading font-bold uppercase tracking-[0.18em] text-xs text-muted-foreground mb-9">Awarded for excellence</p>
    <div className="relative w-full">
      <div className="flex items-center gap-20 animate-marquee w-max">
        {[...BRANDS, ...BRANDS].map((b, i) => (
          <img key={`${b.alt}-${i}`} src={b.src} alt={b.alt} className="h-12 md:h-16 w-auto object-contain grayscale opacity-70 hover:grayscale-0 hover:opacity-100 transition-all duration-300" loading="lazy" />
        ))}
      </div>
    </div>
  </section>
);
